function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 *  Accordion
 *    Scripts for controlling accordions.
 *
 *  Version:
 *    1.0.0 - 2020/03/04
 */

export var SLIDE_SELECTOR = '[data-accordion-slide]';
export var TITLE_SELECTOR = '[data-accordion-title]';
export var BODY_SELECTOR = '[data-accordion-body]';
export var EXPANDED_CLASS = 'is-expanded';
export var Accordion = /*#__PURE__*/function () {
  function Accordion(container) {
    var _this = this;
    _classCallCheck(this, Accordion);
    this.container = container;

    //Settings
    this.allowMultiple = container.attr('data-multiple') == "true" ? true : false;

    //Setup data attributes
    var slides = container.find(SLIDE_SELECTOR);
    slides.each(function (i, e) {
      _this.setSlideIndex($(e), i);
    });

    //Event listeners
    container.on('click', TITLE_SELECTOR, function (e) {
      return _this.onTitleClick(e);
    });
    this.checkExpanded();
  }
  _createClass(Accordion, [{
    key: "checkExpanded",
    value: function checkExpanded() {
      var expand = this.container.find("".concat(SLIDE_SELECTOR, ".").concat(EXPANDED_CLASS));
      expand.each(function (i, e) {
        var self = $(e);
        self.find(BODY_SELECTOR).slideDown(0);
      });
    }
  }, {
    key: "setSlideIndex",
    value: function setSlideIndex(slide, index) {
      //Does this node already have an index?
      var existingIndex = slide.attr('data-index');
      if (existingIndex) return; //Yes, don't do anything

      //If there's no index supplied, find an available one.
      if (_typeof(index) === (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) {
        var i = 0;
        while (true) {
          //Is this index taken by another slide?
          var existing = this.container.find("".concat(SLIDE_SELECTOR, "[data-index=\"").concat(i, "\"]"));
          if (existing.length) {
            i++;
            continue;
          } //Taken
          index = "".concat(i);
          break;
        }
      }

      //Setup indexes
      slide.attr('data-index', index);
      slide.find("".concat(TITLE_SELECTOR, ",").concat(BODY_SELECTOR)).attr('data-index', index);
    }
  }, {
    key: "getSlide",
    value: function getSlide(index) {
      //Find slide by index
      return this.container.find("".concat(SLIDE_SELECTOR, "[data-index=\"").concat(index, "\"]"));
    }
  }, {
    key: "useSlide",
    value: function useSlide(index) {
      //Get slide
      var slide = this.getSlide(index);
      var slideBody = slide.find(BODY_SELECTOR);
      var slideBodies = this.container.find(BODY_SELECTOR);

      //If Multiple just toggle
      if (this.allowMultiple) return slide.toggleClass(EXPANDED_CLASS);

      //Not multple, is currently open?
      var close = slide.hasClass(EXPANDED_CLASS);
      this.container.find(SLIDE_SELECTOR).removeClass(EXPANDED_CLASS); //Close all
      slideBodies.slideUp(200);
      if (close) return; //If was open, leave closed

      //Was not opened before, open now.
      slide.addClass(EXPANDED_CLASS);
      slideBody.slideDown(200);
    }
  }, {
    key: "onTitleClick",
    value: function onTitleClick(e) {
      //Get Element
      var self = $(e.currentTarget);
      var slideContainer = self.parent(SLIDE_SELECTOR);
      this.setSlideIndex(slideContainer);
      var index = parseInt(self.attr('data-index')); //Get Index
      if (isNaN(index)) return; //Has index?

      //Set Slide
      this.useSlide(index);
    }
  }]);
  return Accordion;
}();